'use strict';

namespace Quote {

    export interface BasketNoteCapture {
        Text: string;
    }

    class BasketNotes {

        public newNote: BasketNoteCapture | null;
        public notes: Core.Booking.Note[];
        public basketId:string;
        public basketType:string;

        constructor(
            private quoteService:Quote.QuoteService,
            private basketStore
        ) {
        }

        createNote(): void {
            this.newNote = { Text: '' };
        }

        addNote(): void {
            if (!this.newNote) { return; }
            const text = this.newNote.Text;
            let promise;

            if (this.basketType === 'basket') {
                promise = this.basketStore.addNote(this.basketId, text);
            } else if (this.basketType === 'quote') {
                promise = this.quoteService.addNote(this.basketId, text);
            }

            promise.then(basket => {
                this.newNote = null;
                this.notes = basket.Notes;
            });
        }

        getDate(note): Date {
            return new Date(note.Created + '+00:00');
        }
    }

    angular
        .module('quote')
        .directive('basketNotes', (): ng.IDirective => {
            return {
                restrict: 'E',
                scope: {},
                bindToController: {
                    notes: '=',
                    basketId: '=',
                    basketType: '@'
                },
                templateUrl: 'partials/quote/directivetemplate?type=notes',
                controller: BasketNotes,
                controllerAs: 'n'
            };
        });
}
